import { render, staticRenderFns } from "./detailvalueIntconfig.vue?vue&type=template&id=7f41580a&scoped=true&"
import script from "./detailvalueIntconfig.vue?vue&type=script&lang=js&"
export * from "./detailvalueIntconfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f41580a",
  null
  
)

export default component.exports